import { render, staticRenderFns } from "./EditChangePopup.vue?vue&type=template&id=64c0adfe"
import script from "./EditChangePopup.vue?vue&type=script&lang=js"
export * from "./EditChangePopup.vue?vue&type=script&lang=js"
import style0 from "./EditChangePopup.vue?vue&type=style&index=0&id=64c0adfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports